import { createRouter, createWebHistory } from "vue-router";
import Home from "../components/HomePage.vue";
import ContentSelectionPage from "@/components/shopping-cart/ContentSelectionPage.vue";
import Favorites from "../components/FavoritePage.vue";
import Notifications from "../components/notifications/NotificationPage.vue";
import InboxPage from "@/components/InboxPage.vue"; // Static Import for Inbox Page
import SentPage from "@/components/SentPage.vue"; // Static Import for Sent Page
import TrashPage from "@/components/TrashPage.vue"; // Static Import for Trash Page
import ArchivePage from "@/components/ArchivePage.vue"; // Static Import for Archive Page
import Settings from "../components/SettingPage.vue";
import SOS from "../components/SOS.vue";
import LoginPage from "@/components/authentication/LoginPage.vue";
import AccountSetup from "@/components/authentication/AccountSetup.vue";
import ChatBot from "@/components/ChatBot.vue";
import PageComponent from "@/components/PageComponent.vue";
import SubPage from "@/components/SubPage.vue";
import WebPageTemplate from "@/components/WebPageTemplate.vue";
import MenuCrudPage from "@/components/menu-crud/menuCrudPage.vue";
import JournalPage from "@/components/journal/JournalPage.vue";
import TestTemplate from "@/components/shopping-cart/TestTemplate.vue";
import MyProgressPage from "@/components/my-progress/MyProgressPage.vue";
import ProviderPage from "@/components/shopping-cart/ProviderPage.vue";
import AssessmentPage from "@/components/AssessmentPage.vue";
import Workbook from "@/components/workbook/WorkbookPage.vue";
import ProfilePage from '@/components/ProfilePage.vue';
import ResetPassword from "@/components/authentication/ResetPassword.vue";
import axios from "axios";
import ForgotPassword from "@/components/authentication/ForgotPassword.vue";
import TherapyWorksheets from "@/components/TherapyWorksheets.vue";
import ClinicalAssessmentsPage from "@/components/clinical-assessments/ClinicalAssessmentsPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  {
    path: "/menuCrud",
    name: "MenuCrud",
    component: MenuCrudPage,
  },
  {
    path: "/provider",
    name: "Provider",
    component: ProviderPage,
  },
  {
    path: "/clinical-assessments",
    name: "ClinicalAssessments",
    component: ClinicalAssessmentsPage,
  },
  {
    path: "/provider/content-selection",
    name: "ContentSelection",
    component: ContentSelectionPage,
    props: (route) => ({
      patientId: route.query.patientId,
      planId: route.query.planId,
      isEdit: route.query.isEdit,
      isNew: route.query.isNew,
    }),
  },
  {
    path: "/favorites",
    name: "Favorites",
    component: Favorites,
  },
  {
    path: "/journal",
    name: "Journal",
    component: JournalPage,
  },
  {
    path: "/messages/inbox",
    name: "Inbox",
    component: InboxPage, // Static Import Used Here
  },
  {
    path: "/messages/:id",
    name: "MessageDetail",
    component: () => import("@/components/MessageDetailPage.vue"),
    props: true,
  },
  {
    path: "/messages/sent",
    name: "Sent",
    component: SentPage, // Static Import Used Here
  },
  {
    path: "/testtemplate",
    name: "TestTemplate",
    component: TestTemplate,
  },
  {
    path: "/messages/trash",
    name: "Trash",
    component: TrashPage, // Static Import Used Here
  },
  {
    path: "/messages/archive",
    name: "Archive",
    component: ArchivePage, // Static Import Used Here
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/chatbot",
    name: "ChatBot",
    component: ChatBot,
  },
  {
    path: "/my-progress",
    name: "MyProgress",
    component: MyProgressPage,
    props: (route) => ({
      patientId: route.query.patientId,
      isProviderView: route.query.isProviderView,
    }),
  },
  {
    path: "/page/:pageid",
    name: "Page",
    component: PageComponent,
    props: route => ({ pageid: route.params.pageid, contentId: route.query.contentId}),
  },
  {
    path: "/subpage/:subpageid",
    name: "SubPage",
    component: SubPage,
    props: true,
  },
  {
    path: "/sos",
    name: "SOS",
    component: SOS,
  },
  {
    path: "/webpagetemplate",
    name: "WebPageTemplate",
    component: WebPageTemplate,
  },
  {
    path: "/workbook",
    name: "Workbook",
    component: Workbook,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "AccountSetup",
    component: AccountSetup,
  },
  {
    path: "/assessment",
    name: "Assessment",
    component: AssessmentPage
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage
  },
  {
    path: '/reset-password',
    name: 'ResetPasswordPage',
    component: ResetPassword,
    props: (route) => ({
      email: route.query.email,
      token: route.query.token,
    }),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPasswordPage',
    component: ForgotPassword
  },
  {
    path: '/therapy-worksheets',
    name: 'TherapyWorksheets',
    component: TherapyWorksheets
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;

  // Pages accessible by anonymous users
  let pages = ['AccountSetup', 'LoginPage', 'ForgotPasswordPage', 'ResetPasswordPage'];
  if (!pages.includes(to.name)){  // Check if user has authentication
    try {
      const token = localStorage.getItem("JwtToken");

      if(token != null){
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await axios.get("api/auth", {
          // headers: {
          //   Authorization: `Bearer ${token}`
          // }
        })
      }else{
        await axios.get("api/auth", {withCredentials: true});
      }
      
      next();
    } catch(error){  // Direct to login page if unauthenticated
      next({name: 'LoginPage'});
    }
  } else{
    next();
  }
});


export default router;
